import { GzIntegrationsMarketplaceCardWebComponent } from './component/GzIntegrationsMarketplaceCardWebComponent';

export { GzIntegrationsMarketplaceCardWebComponent };
